import { Card, Grid } from "@mui/material";
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import BasicLineChart from "examples/Charts/LineCharts/BasicLineChart";
import {
  FreightIndexZones,
  FreightIndexZonesTimePeriods,
  FreightIndexZonesTimePeriodsLoggedIn,
  FreightIndexZonesLoggedIn,
  lineChartOptionsDashboard
} from "../../data/freightIndexChart";
import VuiSelect from "../../../../components/VuiSelect";
import CircularProgress from "@mui/material/CircularProgress";
import {useState, useEffect, useMemo} from "react";

const PMTPKChart = ({lines, months, zone, timePeriod, zoneChange, timePeriodChange, loaderState=false, PMTPKdifference, loggedIn}) => {

  const [linesData, setLinesData] = useState(lines);
  const [monthData, setMonthData] = useState(months);
  const [difference, setDifference] = useState(PMTPKdifference);
  const [showloader, setShowloader] = useState(loaderState);

  useEffect(() => {
    setLinesData(lines);
    setMonthData(months);
    setDifference(PMTPKdifference);
    setShowloader(loaderState)
  }, [lines, months, PMTPKdifference, loaderState]);

  return (
    <>
      <Grid container mb={2}>
        <Grid item xs={7} sm={8} lg={9} textAlign={"right"}>
          <small>
          <VuiTypography color={"text"} variant={"md"}>
          Number of months
          </VuiTypography>
          </small>
        </Grid>
        <Grid item xs={5} sm={4} lg={3} pl={1}>
          <VuiSelect placeholder="Time period" options={loggedIn ? FreightIndexZonesTimePeriodsLoggedIn : FreightIndexZonesTimePeriods} name={"timeperiod"} value={timePeriod} isClearable={false} onChange={timePeriodChange} isDisabled={showloader} />
        </Grid>
      </Grid>
    <Card>
      <VuiBox sx={{ height: "100%" }}>
        <Grid container>
        <Grid item xs={12} sm={8} md={7} lg={8} xl={9}>
          <VuiBox mb={1}>
            <VuiTypography variant="h5" textTransform="capitalize"
              fontWeight="800"
              color="#3b3663">
              Rate Per Ton Per Km
            </VuiTypography>
          </VuiBox>
          {
            useMemo(() => (
              <VuiBox display="flex" alignItems="center" mb="10px">
                {monthData ?

              // For color dynamic code - {difference > 0 ? "error": (difference < 0 ? "success": "white")}
              <VuiTypography variant="button" color={difference > 0 ? "error": (difference < 0 ? "success": "text")} fontWeight="bold">
                {/* {difference === 0 ? 'Since no change' : difference + '%'} {" "} */}
                {difference}% <span style={{fontSize: '20px', fontWeight: '700'}}>{difference > 0 ? "↓ " : (difference < 0 ? "↑ ": "")}</span>
                <VuiTypography variant="button" color="text" fontWeight="regular">
                  in {monthData[monthData.length - 1].substring(0, 3) + " '" + monthData[monthData.length - 1].slice(-2)} vs. {monthData[monthData.length - 2].substring(0, 3) + " '" + monthData[monthData.length - 2].slice(-2)}
                </VuiTypography>
              </VuiTypography>
                  : ""}
              </VuiBox>
            ), [monthData])
          }
        </Grid>
          <Grid item xs={12} sm={'auto'} md={5} lg={4} xl={3}>
            <VuiSelect placeholder="Zone" options={loggedIn ? FreightIndexZonesLoggedIn : FreightIndexZones} name={"zone"} value={zone} isMulti={true} isClearable={false} onChange={zoneChange} isDisabled={showloader} />
          </Grid>
        </Grid>
      </VuiBox>
      {
        useMemo(() => (
          <VuiBox sx={{height: "310px"}}>
            {linesData ?
              <BasicLineChart
                chartData={linesData}
                categories={monthData}
                chartOptions={lineChartOptionsDashboard}
              />
              : ""
            }
            {showloader ?
              <Grid item xs={12} textAlign={"center"} top={"40%"}  position={"absolute"} width={"100%"}>
                <CircularProgress size={"4rem"} color={"text"}/>
              </Grid>
              :
              ""}
          </VuiBox>
        ), [linesData, showloader, monthData])
      }
    </Card>
      </>
  );
};

export default PMTPKChart;
